exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ebx-close{cursor:pointer}.ebx-close__icon{height:1em;width:auto}", ""]);
